import { Form, FormikProvider, useFormik } from 'formik';
import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';
import { Box, Stack, TextField, MenuItem } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { useSnackbar } from 'notistack';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { AddButton } from '../../../components/mui/Buttons/Buttons';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { addLogs } from '../../../redux/features/feeForecastSlice';
import useHandleApiResponse from '../../../Hooks/useHandleApiResponse';
import { useEffect } from 'react';

const AddForecastLogs = ({ open, setOpen, enrollId, setEnrollId }) => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.feeForecast);
  const handleApiResponse = useHandleApiResponse();

  const Schema = Yup.object().shape({
    expectedSessions: Yup.string().required('Expected Sessions is required'),
    forcastCalculatedMethod: Yup.string().required('forcast Calculated Method is required'),
    amountToCollect: Yup.string().required('Amount To Collect is required'),
  });

  const formik = useFormik({
    initialValues: {
      courseEnrollmentId: '',
      month: dayjs().format('MM'),
      year: dayjs().format('YYYY'),
      expectedSessions: '',
      forcastCalculatedMethod: '',
      amountToCollect: '',
    },
    validationSchema: Schema,
    onSubmit: (values, { resetForm }) => {
      dispatch(addLogs(values)).then((res) => {
        handleApiResponse(res, {
          onSuccess: () => {
            setOpen(false);
            setEnrollId(null);
            resetForm();
          },
          onFailed: () => {
            console.log('Something went wrong');
          },
        });
      });
    },
  });
  useEffect(() => {
    if (open) {
      formik.setFieldValue('courseEnrollmentId', enrollId);
    }
  }, [open]);

  const methodOptions = [
    { id: 1, name: 'Option' },
    { id: 2, name: 'Percentage' },
  ];

  return (
    <GlobalDialog
      title={'Add Forecast Log'}
      open={open}
      setOpen={setOpen}
      maxWidth={'sm'}
      closeButton={true}
      fullWidth
      content={
        <>
          {open ? (
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Box>
                  <Stack spacing={2}>
                    {/* Month & Year Picker */}
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        views={['year', 'month']}
                        label="Select Month & Year"
                        value={
                          formik.values.month && formik.values.year
                            ? dayjs(`${formik.values.year}-${formik.values.month}-01`)
                            : dayjs()
                        }
                        onChange={(value) => {
                          if (value) {
                            formik.setFieldValue('month', value.month() + 1);
                            formik.setFieldValue('year', value.year());
                          }
                        }}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                          },
                        }}
                      />
                    </LocalizationProvider>

                    {/* Expected Sessions */}
                    <TextField
                      label="Expected Sessions"
                      name="expectedSessions"
                      type="number"
                      fullWidth
                      value={formik.values.expectedSessions}
                      onChange={formik.handleChange}
                      error={formik.touched.expectedSessions && Boolean(formik.errors.expectedSessions)}
                      helperText={formik.touched.expectedSessions && formik.errors.expectedSessions}
                    />

                    {/* Forecast Calculated Method */}
                    <TextField
                      select
                      label="Forecast Calculated Method"
                      name="forcastCalculatedMethod"
                      fullWidth
                      value={formik.values.forcastCalculatedMethod}
                      onChange={formik.handleChange}
                      error={formik.touched.forcastCalculatedMethod && Boolean(formik.errors.forcastCalculatedMethod)}
                      helperText={formik.touched.forcastCalculatedMethod && formik.errors.forcastCalculatedMethod}
                    >
                      {methodOptions.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </TextField>

                    {/* Amount To Collect */}
                    <TextField
                      label="Amount To Collect"
                      name="amountToCollect"
                      type="number"
                      fullWidth
                      value={formik.values.amountToCollect}
                      onChange={formik.handleChange}
                      error={formik.touched.amountToCollect && Boolean(formik.errors.amountToCollect)}
                      helperText={formik.touched.amountToCollect && formik.errors.amountToCollect}
                    />
                  </Stack>
                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <AddButton disabled={loading} size={'small'} type={'submit'}>
                      {loading ? 'Please Wait...' : 'Add Log'}
                    </AddButton>
                  </Box>
                </Box>
              </Form>
            </FormikProvider>
          ) : null}
        </>
      }
    />
  );
};

export default AddForecastLogs;
